import { useMutation } from "@apollo/client";
import { useDispatch } from "react-redux";

import {
    SET_EXPLICIT_STATUS_ON_UPLOADS,
    SET_NEEDS_RELEASE_STATUS_ON_UPLOADS,
    SET_EDITORIAL_USE_ONLY_ON_UPLOADS,
    SET_HAS_WARNING_TEXT_ON_UPLOADS
} from "../mutations.js";

import { unblurUpload } from "../slices/uploadFooterActionsSlice";

const useClearFlags = () => {
    const dispatch = useDispatch();

    const [setExplicitStatus] = useMutation(SET_EXPLICIT_STATUS_ON_UPLOADS);

    const [setNeedsReleaseStatus] = useMutation(
        SET_NEEDS_RELEASE_STATUS_ON_UPLOADS
    );

    const [setEditorialUseOnly] = useMutation(
        SET_EDITORIAL_USE_ONLY_ON_UPLOADS
    );

    const [setHasWarningText] = useMutation(SET_HAS_WARNING_TEXT_ON_UPLOADS);

    const clearExplicitStatus = (uploadIds = []) => {
        setExplicitStatus({
            variables: {
                photoUploadIds: uploadIds,
                value: false
            }
        }).then(res => {
            if (res.data.setExplicitStatusOnUploads.ok) {
                uploadIds.forEach(id => {
                    dispatch(unblurUpload(id));
                });
            }
        });
    };

    const clearNeedsReleaseStatus = (uploadIds = []) => {
        setNeedsReleaseStatus({
            variables: {
                photoUploadIds: uploadIds,
                value: false
            }
        });
    };

    const clearEditorialUseOnly = (uploadIds = []) => {
        setEditorialUseOnly({
            variables: {
                photoUploadIds: uploadIds,
                value: false
            }
        });
    };

    const clearHasWarningText = (uploadIds = []) => {
        setHasWarningText({
            variables: {
                photoUploadIds: uploadIds,
                value: false
            }
        });
    };

    return {
        clearExplicitStatus,
        clearNeedsReleaseStatus,
        clearEditorialUseOnly,
        clearHasWarningText
    };
};

export default useClearFlags;
